module.exports = __webpack_public_path__ + "static/media/login.2bfd0a29.svg";